// Vue
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export class EventBus extends Vue {
  public dispatch(componentName, event, params) {
    let parent = this.$parent || this.$root;
    let name = parent.$options.name;

    if (!parent) {
      return;
    }

    while (parent && (!name || name !== componentName)) {
      parent = parent.$parent!;

      if (parent) {
        name = parent.$options.name;
      }
    }

    if (parent) {
      parent.$emit.apply(parent, ([event] as any).concat(params));
    }
  }

  public broadcast(componentName: string, event: string, params: any[]) {
    this.searchForComponent(this.$children, componentName, event, params);
  }

  public searchForComponent(children: Vue[], componentName: string, event: string, params: any[]) {
    children.forEach((child) => {
      let name = child.$options.name;

      if (name === componentName) {
        child.$emit.apply(child, ([event] as any).concat(params));
      } else if (child.$children && child.$children.length) {
        this.searchForComponent(child.$children, componentName, event, params);
      }
    });
  }

  public broadcastAll(event: string, params: any[]) {
    this.broadcastAllChildren(this.$children, event, params);
  }

  private broadcastAllChildren(children: Vue[], event, params) {
    children.forEach((child) => {
      child.$emit.apply(child, ([event] as any).concat(params));

      if (child.$children && child.$children.length > 0) {
        this.broadcastAllChildren(child.$children, event, params);
      }
    });
  }
}
